import { useFormikContext } from "formik";
import NewAnalysisHeader from "./modes/NewAnalysisHeader";
import { ACTION_VIEW_MODE } from "../../../../constants/action-form";
import { ActionModalHeaderStyled } from "../ActionModalHeaderStyled";

const AnalysisHeader = ({ isLoading }) => {
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    submitForm();
  };

  const viewMode = ACTION_VIEW_MODE.new;

  return (
    <ActionModalHeaderStyled>
      {viewMode === ACTION_VIEW_MODE.new && (
        <NewAnalysisHeader onSubmit={handleSubmit} isLoading={isLoading} />
      )}
    </ActionModalHeaderStyled>
  );
};

export default AnalysisHeader;
